module.exports = __webpack_public_path__ + "../resources/img/ic-re-info.0a7fca0a.svg";